import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '../Styleguide/Button'
import * as botActions from '../../actions/bot'
import { latestVersionFlowSelector } from '../../features/serverBots/selectors'

export const Error: React.FC = () => {
  const dispatch = useDispatch()
  const originalVersion = useSelector(latestVersionFlowSelector)

  return (
    <ErrorWrapper>
      <FontAwesomeIcon icon="heart-broken" size="4x" />
      <ErrorTitle>
        Something went wrong{' '}
        <span role="img" aria-label="Sad">
          😢
        </span>
      </ErrorTitle>
      <StyledActionButtons>
        <ActionButton
          text="Reload designer"
          onClick={() => {
            window.location.href = '/'
          }}
        />
        &nbsp;
        <ActionButton
          text="Discard changes and reload"
          onClick={() => {
            dispatch(botActions.discardChanges(originalVersion))
            window.location.href = '/'
          }}
        />
        &nbsp;
        <ActionButton
          text="Clear cached data and reload"
          onClick={() => {
            window.localStorage.clear()
            window.location.href = '/'
          }}
        />
      </StyledActionButtons>
    </ErrorWrapper>
  )
}

const ActionButton = styled(Button)`
  margin: 0 5px;
`

const ErrorWrapper = styled.div`
  padding-top: 40px;
  text-align: center;
`

const ErrorTitle = styled.div`
  font-size: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
`

const StyledActionButtons = styled.div`
  display: flex;
  width: 350px;
  margin: 2px auto;
  flex-direction: column;
  justify-content: space-between;
`
